import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LanguageService, AppLang } from '../../services/language.service';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <!-- Variante bandeiras (ex.: rodapé do card de login) -->
    <div *ngIf="variant === 'flags'" class="lang-flags">
      <button
        type="button"
        class="lang-flag"
        [class.active]="current === 'pt-BR'"
        [attr.aria-pressed]="current === 'pt-BR'"
        [title]="labels['pt-BR']"
        aria-label="Português"
        (click)="onChange('pt-BR')">
        <svg viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg">
          <rect width="28" height="20" rx="2" fill="#009b3a" />
          <path d="M14 3 L25 10 L14 17 L3 10 Z" fill="#ffdf00" />
          <circle cx="14" cy="10" r="4.2" fill="#002776" />
        </svg>
      </button>
      <button
        type="button"
        class="lang-flag"
        [class.active]="current === 'en'"
        [attr.aria-pressed]="current === 'en'"
        [title]="labels['en']"
        aria-label="English"
        (click)="onChange('en')">
        <svg viewBox="0 0 28 20" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <clipPath id="us-rc"><rect width="28" height="20" rx="2" /></clipPath>
          </defs>
          <g clip-path="url(#us-rc)">
            <rect width="28" height="20" fill="#fff" />
            <g fill="#b22234">
              <rect y="0" width="28" height="1.54" />
              <rect y="3.08" width="28" height="1.54" />
              <rect y="6.15" width="28" height="1.54" />
              <rect y="9.23" width="28" height="1.54" />
              <rect y="12.31" width="28" height="1.54" />
              <rect y="15.38" width="28" height="1.54" />
              <rect y="18.46" width="28" height="1.54" />
            </g>
            <rect width="12" height="10.77" fill="#3c3b6e" />
          </g>
        </svg>
      </button>
    </div>

    <!-- Variante padrão (dropdown, ex.: header) -->
    <div *ngIf="variant === 'select'" class="lang-switcher" title="Idioma / Language">
      <i class="fas fa-globe text-gray-400 text-sm" aria-hidden="true"></i>
      <select
        [ngModel]="current"
        (ngModelChange)="onChange($event)"
        aria-label="Idioma / Language"
        class="lang-select">
        <option *ngFor="let lang of langs" [value]="lang">{{ labels[lang] }}</option>
      </select>
    </div>
  `,
  styles: [`
    .lang-switcher { display: inline-flex; align-items: center; gap: .375rem; }
    .lang-select {
      border: 1px solid var(--border); border-radius: .375rem; padding: .25rem 1.5rem .25rem .5rem;
      font-size: .875rem; color: var(--text-secondary); background-color: var(--surface); cursor: pointer;
    }
    .lang-select:focus { outline: none; border-color: var(--text-muted); }

    .lang-flags { display: inline-flex; align-items: center; gap: .75rem; }
    .lang-flag {
      display: inline-flex; padding: 0; background: none; border: none; cursor: pointer;
      line-height: 0; opacity: .45; filter: grayscale(60%);
      transition: opacity .15s ease, filter .15s ease, transform .15s ease;
    }
    .lang-flag:hover { opacity: .85; filter: grayscale(0); }
    .lang-flag.active { opacity: 1; filter: grayscale(0); transform: scale(1.06); }
    .lang-flag svg {
      width: 28px; height: 20px; border-radius: 3px; display: block;
      box-shadow: 0 0 0 1px rgba(0,0,0,.08);
    }
    .lang-flag.active svg { box-shadow: 0 0 0 2px var(--brand); }
  `],
})
export class LanguageSwitcherComponent {
  /** 'select' = dropdown (header); 'flags' = bandeiras (login/landing footer). */
  @Input() variant: 'select' | 'flags' = 'select';

  readonly langs: AppLang[];
  readonly labels: Record<AppLang, string> = { 'pt-BR': 'Português', en: 'English' };

  constructor(private readonly languageService: LanguageService) {
    this.langs = this.languageService.available;
  }

  get current(): AppLang {
    return this.languageService.current;
  }

  onChange(lang: AppLang): void {
    this.languageService.setLang(lang);
  }
}
